export default __webpack_public_path__ + "static/media/execute_PP2.e2da7d19.png";